import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const LastUpdate = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  ${({ theme }) => theme.typograph.paragraphMedium};
  span {
    margin-left: 8px;
    ${({ theme }) => theme.typograph.paragraphRegular};
  }
`;

const Icon = styled(ReactSVG)`
  height: 24px;
  width: 24px;
  margin-right: 16px;
  
  path {
    fill: ${({ theme }) => theme.colors.gray300};
  }
`;

const ModificationsText = styled.p`
  ${({ theme, hasModification }) => (hasModification ? theme.typograph.paragraphMedium : theme.typograph.paragraphRegular)};
  color: $${({ theme, hasModification }) => (hasModification ? theme.colors.mainColor : theme.colors.textColorSecondary)};
  margin-right: 24px;
`;

const ModalContentContainer = styled.p`
  width: 412px;
  ${({ theme }) => theme.typograph.paragraphRegular};
`;

export {
  PageWrapper,
  ButtonWrapper,
  LastUpdate,
  Icon,
  ModificationsText,
  ModalContentContainer,
};
